module.exports = __webpack_public_path__ + "static/media/mail.5a8379ea.svg";